<template>
  <footer class="Footer">
    版权所有 ©2012-{{ year }} 久其数字传播有限公司 &nbsp;&nbsp;&nbsp;&nbsp;
    <el-link href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">京ICP备18018614号-6</el-link>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <el-link href="https://pandarocket.cn/PANDAEDI" rel="noreferrer" target="_blank"
      >增值电信业务经营许可证：京B2-20203609 B2-20203609</el-link
    >
    &nbsp;&nbsp;&nbsp;&nbsp;
    <el-link
      rel="noreferrer"
      target="_blank"
      href="https://beian.mps.gov.cn/#/query/webSearch?code=11030102011668"
      ><img
        style="width: 16px; vertical-align: sub"
        :src="`${common.imageRoot}/copyrightimg.png`"
      />京公网安备11030102011668号</el-link
    >
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.Footer {
  position: relative;
  width: 100%;
  bottom: 10px;
  text-align: center;
  font-family:
    PingFangSC,
    PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
